import { SingleTag } from '../index'

export default function GetSingleTagFunc(currDishId: string) {
  return SingleTag(currDishId)
}
